interface BarmaidLogoProps {
  className?: string;
  size?: number;
  withWordmark?: boolean;
}

function cn(...parts: (string | false | undefined)[]) {
  return parts.filter(Boolean).join(" ");
}

const VIEWBOX_W = 540;
const VIEWBOX_H = 631;

const BARMAID_MARK_PATH =
  "M 139.00 618.50 L 75.00 617.50 L 56.00 612.50 L 44.00 606.50 L 28.50 593.00 L 19.50 580.00 L 12.50 561.00 L 11.50 77.00 L 15.50 61.00 L 25.50 43.00 L 41.00 27.50 L 54.00 19.50 L 64.00 15.50 L 82.00 11.50 L 319.00 11.50 L 343.00 14.50 L 368.00 21.50 L 400.00 37.50 L 419.00 51.50 L 433.50 65.00 L 444.50 78.00 L 459.50 101.00 L 465.50 113.00 L 474.50 138.00 L 480.50 172.00 L 480.50 202.00 L 478.50 219.00 L 469.50 251.00 L 461.50 268.00 L 451.50 283.00 L 467.00 294.50 L 491.50 321.00 L 505.50 342.00 L 519.50 374.00 L 526.50 406.00 L 527.50 444.00 L 522.50 478.00 L 516.50 497.00 L 499.50 531.00 L 486.50 549.00 L 475.50 561.00 L 446.00 585.50 L 419.00 600.50 L 384.00 612.50 L 351.00 617.50 L 331.00 617.50 L 318.00 615.50 L 299.00 609.50 L 286.00 601.50 L 273.50 590.00 L 266.50 581.00 L 260.50 569.00 L 256.50 553.00 L 256.50 532.00 L 254.50 529.00 L 256.50 519.00 L 255.50 369.00 L 256.50 361.00 L 260.50 352.00 L 270.00 344.50 L 292.00 331.50 L 305.50 319.00 L 315.50 306.00 L 325.50 285.00 L 328.50 272.00 L 327.50 260.00 L 323.00 256.50 L 166.00 256.50 L 161.50 260.00 L 160.50 267.00 L 163.50 282.00 L 172.50 303.00 L 191.00 325.50 L 202.00 334.50 L 225.00 348.50 L 231.50 359.00 L 232.50 547.00 L 229.50 566.00 L 224.50 579.00 L 214.50 593.00 L 204.00 602.50 L 189.00 611.50 L 174.00 616.50 L 139.00 618.50 Z M 161.50 574.00 L 174.00 571.50 L 183.00 566.50 L 188.50 560.00 L 192.50 550.00 L 192.50 379.00 L 170.00 362.50 L 154.50 348.00 L 137.50 326.00 L 126.50 304.00 L 120.50 280.00 L 119.50 243.00 L 121.50 234.00 L 125.50 227.00 L 132.00 221.50 L 137.00 219.50 L 347.00 218.50 L 357.00 221.50 L 366.50 231.00 L 369.50 243.00 L 369.50 274.00 L 365.50 296.00 L 360.50 309.00 L 351.50 326.00 L 336.50 346.00 L 315.00 365.50 L 296.50 378.00 L 295.50 539.00 L 298.50 556.00 L 308.00 567.50 L 320.00 572.50 L 324.00 571.50 L 327.00 573.50 L 341.00 573.50 L 343.00 571.50 L 354.00 572.50 L 385.00 565.50 L 416.00 551.50 L 437.00 536.50 L 454.50 518.00 L 466.50 500.00 L 473.50 484.00 L 481.50 451.00 L 481.50 415.00 L 477.50 396.00 L 471.50 378.00 L 463.50 362.00 L 452.50 346.00 L 429.00 323.50 L 402.00 306.50 L 395.50 299.00 L 392.50 292.00 L 392.50 283.00 L 394.50 279.00 L 409.50 263.00 L 417.50 252.00 L 424.50 239.00 L 431.50 218.00 L 435.50 185.00 L 434.50 167.00 L 431.50 150.00 L 420.50 122.00 L 405.50 100.00 L 383.00 79.50 L 374.00 73.50 L 353.00 63.50 L 337.00 58.50 L 318.00 55.50 L 89.00 55.50 L 78.00 58.50 L 71.00 62.50 L 60.50 75.00 L 57.50 91.00 L 58.50 552.00 L 64.50 564.00 L 71.00 569.50 L 80.00 573.50 L 161.50 574.00 Z";

export function BarmaidMark({ className, size = 28 }: { className?: string; size?: number }) {
  const gradId = `barmaid-grad-${size}`;
  const height = size;
  const width = (size * VIEWBOX_W) / VIEWBOX_H;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${VIEWBOX_W} ${VIEWBOX_H}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
      aria-hidden
    >
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#8C45FF" />
          <stop offset="48%" stopColor="#F020F3" />
          <stop offset="100%" stopColor="#FF4F8D" />
        </linearGradient>
      </defs>
      <path d={BARMAID_MARK_PATH} fill={`url(#${gradId})`} fillRule="evenodd" />
    </svg>
  );
}

export default function BarmaidLogo({
  className,
  size = 28,
  withWordmark = true,
}: BarmaidLogoProps) {
  return (
    <div className={cn("inline-flex items-center gap-2.5", className)}>
      <BarmaidMark size={size} />
      {withWordmark && (
        <span
          className="font-display font-bold tracking-tight text-foreground"
          style={{ fontSize: size * 0.78, letterSpacing: "-0.02em" }}
        >
          Barmaid
        </span>
      )}
    </div>
  );
}
